'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WeekDays = require('./WeekDays');

var _WeekDays2 = _interopRequireDefault(_WeekDays);

var _DateUtils = require('../../utils/DateUtils');

var _Days = require('./Days');

var _Days2 = _interopRequireDefault(_Days);

var _DayPicker = require('./DayPicker.scss');

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DayPicker lays out the days of the week and the weekday labels.
 */
var DayPicker = function DayPicker(props) {

	/**
  * This method will create the grid layout for out calendar. It will lay out Day objects as cells, each of which
  * can fire off a click event and change the state. layOutGrid uses two nested for loops and adds or subtracts from
  * the working date object as needed to fill out the grid.
  * @param firstOfTheMonth the numeric value corresponding to the day of the week which the first falls on indexed 0
  * @param workingDate the full date object, it's initial value should be equal to the first of the month
  */
	var layOutGrid = function layOutGrid(firstOfTheMonth, workingDate) {
		var rows = [];
		var thisMonth = workingDate.month();

		//First let's lay out the days of the week

		for (var i = 0; i < 6; i++) {
			var days = [];
			for (var j = 0; j < 7; j++) {

				/**
     * If we're in the first array and the first of the month does not fall on a sunday
     * We need to go ahead and move the date back equal to the number of days from sunday we are.
     * This should bring us up to the current date where we'll allow the loop below to fill out the
     * rest of dates.
     */
				if (i === 0 && firstOfTheMonth > 0) {
					workingDate.date(workingDate.date() - firstOfTheMonth);
					for (var k = firstOfTheMonth; k > 0; k--) {
						days.push(_react2.default.createElement(
							'td',
							{ className: _DayPicker2.default.prevNextDays, key: workingDate.toISOString() },
							_react2.default.createElement(_Days2.default, {
								onChange: props.onChange,
								day: workingDate.date(),
								month: workingDate.month(),
								year: workingDate.year(),
								value: props.value,
								isDateTime: props.isDateTime })
						));
						workingDate.date(workingDate.date() + 1);
					}
					//Let's bring our loop up to date and make sure we don't hit this loop again
					j = firstOfTheMonth;
					firstOfTheMonth = 0;
				}

				/**
     * We're going to use this method to determine whether the day is in the current month
     * and should use the black text styling or a future month and should use the grey styling.
     * We don't need to scan for previous months because the above loop already does that.
     * @returns true if we're in the current month or false if we're in a future month.
     */
				var monthMatch = function monthMatch() {
					if (workingDate.month() !== thisMonth) {
						return false;
					}
					return true;
				};

				days.push(_react2.default.createElement(
					'td',
					{ className: monthMatch() ? _DayPicker2.default.calendarTd : _DayPicker2.default.prevNextDays, key: workingDate.toISOString() },
					_react2.default.createElement(_Days2.default, { onChange: props.onChange,
						day: workingDate.date(),
						month: workingDate.month(),
						year: workingDate.year(),
						value: props.value,
						isDateTime: props.isDateTime })
				));
				workingDate.date(workingDate.date() + 1);
			}
			rows.push(_react2.default.createElement(
				'tr',
				{ key: i + "" },
				days
			));
		}
		return rows;
	};

	//We need to convert the prop to a Date object
	var date = props.value;
	var dateObject = (0, _moment2.default)(date);

	//Using that date object let's get the current month and year
	var year = dateObject.year();
	var month = dateObject.month();

	//Now lets grab the first of the month as both a numeric value and a date object. layOutGrid needs these both
	var FirstOfmonthFullDate = (0, _DateUtils.getDate)(1, month, year);
	var firstDayofMonth = FirstOfmonthFullDate.day();

	return _react2.default.createElement(
		'table',
		{ className: _DayPicker2.default.table },
		_react2.default.createElement(
			'tbody',
			null,
			_react2.default.createElement(_WeekDays2.default, { daysOfTheWeek: props.daysOfTheWeek }),
			layOutGrid(firstDayofMonth, FirstOfmonthFullDate)
		)
	);
};

DayPicker.propTypes = {
	/**
  * An array of localized days of the week
  */
	daysOfTheWeek: _propTypes2.default.array,
	/**
  * A working instance of a Date or moment Object. Note that this value is not the same as the "value" displayed in the
  * DatePicker's text field but instead should represent the date associated with the state in CwDatPicker.
  */
	value: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_moment2.default), _propTypes2.default.instanceOf(Date)]),
	/**
  * A function that should update the value in the text field when one has been selected from the Calendar.
  */
	onChange: _propTypes2.default.func
};

exports.default = DayPicker;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwdatepicker/DayPicker.js
// module id = 827
// module chunks = 10